'use client';
import { ICustomerPointTaskItem } from '@/api/types/account';
import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Box } from '@mui/material';
import { RightArrowOutlined } from '@zeelool/icon';
import { useTranslations } from '@/i18n/use-translations';
import React, { useState } from 'react';
import { handlePointsTask } from './handlePointsTask';
import PointsTaskDialog from './PointsTaskDialog';
import { TaskItem } from './TaskItem';

const PointsTask: React.FC<{
  customerPointTask: ICustomerPointTaskItem[];
  deviceType: EPlatform;
}> = ({ customerPointTask = [], deviceType }) => {
  const t = useTranslations('account.pointsMall.pointsTask');
  const { trackEvent } = useReporting();
  const taskListData = handlePointsTask(customerPointTask);
  const unCompletedTask = taskListData.filter((item) => Number(item.status) !== 1);
  let taskShow = [];
  if (deviceType === EPlatform.WEB) {
    taskShow = unCompletedTask.slice(0, 2);
  } else {
    taskShow = unCompletedTask[0] ? [unCompletedTask[0]] : [];
  }
  const [dialogShow, setDialogShow] = useState(false);
  const PointsMallPageBtn_Click = (btnName: string) => {
    trackEvent(
      {
        eventName: 'PointsMallPageBtn_Click',
        properties: {
          btn_name: btnName,
        },
      },
      [ProviderType.SENSORS],
    );
  };
  return (
    <Box
      sx={{
        bgcolor: '#f4f4f4',
        borderRadius: '12px',
        p: deviceType === EPlatform.WEB ? 3 : '16px 12px',
        height: '100%',
      }}
    >
      <div className="flex justify-between items-center mb-20">
        {deviceType === EPlatform.WEB ? (
          <span className="text-20 leading-[24px] font-bb">{t('title.web')}</span>
        ) : (
          <span className="text-16 font-bb">{t('title.mobile')}</span>
        )}
        <span
          className={`text-14 leading-[17px] cursor-pointer flex items-center ${
            deviceType === EPlatform.WEB ? 'text-primary-text' : 'text-auxiliary-dark-gray'
          }`}
          onClick={() => {
            setDialogShow(true);
            PointsMallPageBtn_Click('View More');
          }}
        >
          {deviceType === EPlatform.WEB ? t('viewMore.web') : t('viewMore.mobile')}
          <RightArrowOutlined className="text-14 ml-8 text-primary-text" />
        </span>
      </div>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns:
            deviceType === EPlatform.WEB
              ? {
                  xs: 'repeat(2, 1fr)',
                  sm: 'repeat(2, 1fr)',
                  md: 'repeat(2, 1fr)',
                  lg: 'repeat(1, 1fr)',
                  xl: 'repeat(2, 1fr)',
                }
              : 'repeat(1, 1fr)',
          gap: '16px',
        }}
      >
        {taskShow.map((item) => (
          <TaskItem key={item.name} item={item} deviceType={deviceType} />
        ))}
      </Box>
      <PointsTaskDialog
        taskListData={taskListData}
        open={dialogShow}
        onClose={() => setDialogShow(false)}
        deviceType={deviceType}
      />
    </Box>
  );
};

export default PointsTask;
